<!--
  - Copyright (c) 2022.
  - ISNLab
  - Owner and rewriter: Sedov A. Sergey
  - sedov.sergey@isnlab.com
  -->

<template>
  <div class="col-12 col-md-7 col-lg-6 auth-main-col text-center p-5">
    <div class="d-flex flex-column align-content-end">
      <div class="alert alert-danger" v-show="isError" v-html="errorMessage"></div>
      <div class="app-auth-body mx-auto" v-show="!isLoading">
        <div class="app-auth-branding mb-4 mt-4"><img class="logo-icon me-2 img-fluid" src="@/assets/images/logo-aff.png" alt="logo"></div>
        <h2 class="auth-heading text-center mb-3">LOG IN</h2>
        <div class="auth-form-container text-start">
          <form class="auth-form login-form" @submit.prevent="login">
            <div class="email mb-3">
              <label class="sr-only" for="signin-email">Email or username</label>
              <input id="signin-email" name="signin-email" v-model="form.username" type="text" class="form-control signin-email" placeholder="Email or Username" required="required">
            </div><!--//form-group-->
            <div class="password mb-3">
              <label class="sr-only" for="signin-password">Password</label>
              <input id="signin-password" name="signin-password" v-model="form.password" type="password" class="form-control signin-password" placeholder="Password" required="required">
              <div class="extra mt-3 row justify-content-between">
                <div class="col-6">

                </div><!--//col-6-->
                <div class="col-6">
                  <div class="forgot-password text-end">
                    <router-link to="/member/reset">Forgot password?</router-link>
                  </div>
                </div><!--//col-6-->
              </div><!--//extra-->
            </div><!--//form-group-->
            <div class="text-center">
              <button type="submit" class="btn app-btn-primary w-100 theme-btn mx-auto">Log In</button>
            </div>
          </form>

          <div class="auth-option text-center pt-5">No Account? Sign up <router-link class="text-link" to="/member/signup" >here</router-link>.</div>
        </div><!--//auth-form-container-->

      </div><!--//auth-body-->
      <span v-if="isLoading" class="cssload-loader"><span class="cssload-loader-inner"></span></span>
    </div><!--//flex-column-->
  </div><!--//auth-main-col-->
  <div class="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
    <div class="auth-background-login">
    </div>

  </div><!--//auth-background-col-->

</template>

<script>
import {
  isLoading,
  isError,
  errorMessage,
  logout,
  loadingDone,
  doLoading, authSuccess
} from "@/inc/storage";
import {Request} from "@/inc/client";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "LoginPage",
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
    }
  },
  setup(){
    return {
      isLoading, isError, errorMessage
    }
  },
  mounted() {
    logout();
    loadingDone();
  },
  methods: {
    login: function () {
      doLoading();
      let payload = {
        LoginForm: this.form
      }
      Request('login', {data: payload, method: 'POST'})
          .then(function (response) {
            loadingDone();
            authSuccess(response.data)
          })
    }
  }
}
</script>

<style scoped>
</style>